<template lang="pug">
.btns
  #goToTop(@click="scrollToTop")
    a.shadow-sm
      font-awesome-icon(:icon="['fas', 'chevron-up']") 
      span TOP
</template>

<script>
export default {
  name: "FloatTop",
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style scoped lang="scss">
#goToTop {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 9;
  cursor: pointer;

  a {
    display: block;
    background-color: rgba(50, 50, 50, 0.6);
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    width: 55px;
    height: 55px;
    line-height: 16px;
    padding: 12px 0;
    text-align: center;

    &:hover {
      background-color: rgba(8, 43, 107, 0.8);
      text-decoration: underline;
    }

    span {
      display: block;
    }
  }
}

.comments {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 9;

  &:hover {
    bottom: 7.5px;
    right: 7.5px;

    a {
      width: 60px;
      height: 60px;
      padding: 12.5px 0;
    }
  }
  a {
    display: block;
    background-color: #faad00;
    border-radius: 50%;
    color: white;
    font-size: 24px;
    width: 55px;
    height: 55px;
    padding: 10px 0;
    text-align: center;
  }
}
</style>
